import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";


const boreholeWaterBearingApi = createApi({
    reducerPath: "core/waterbearing/borehole",
    baseQuery: axiosBaseQuery,
    tagTypes: ["parameterBoreholeWaterbearing"],
    endpoints: (builder) =>({
        parameterBoreholeWaterbearingFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['parameterBoreholeWaterbearing'],
            query: (query = '') => ({
                url: "core/waterbearing/borehole" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        parameterBoreholeWaterbearingCreate: builder.mutation({
            invalidatesTags: ['parameterBoreholeWaterbearing'],
            query: (data)=>({url: "core/waterbearing/borehole", method: "POST", data})
        }),
        parameterBoreholeWaterbearingUpdate: builder.mutation({
            invalidatesTags: ['parameterBoreholeWaterbearing'],
            query: (data)=>({url: "/core/waterbearing/borehole/"+data.id, method: "PUT", data})
        }),
    
        parameterBoreholeWaterbearingDelete: builder.mutation({
            invalidatesTags: ['parameterBoreholeWaterbearing'],
            query: (id)=>({url: "/core/waterbearing/borehole/"+id, method: "DELETE"})
        }),
    })
})

export const { useParameterBoreholeWaterbearingFindAllQuery, useParameterBoreholeWaterbearingCreateMutation, useParameterBoreholeWaterbearingUpdateMutation, useParameterBoreholeWaterbearingDeleteMutation } = boreholeWaterBearingApi;
export {boreholeWaterBearingApi};
